// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1YgCG","resendInfoText":"OnGoingPaymentBox_resendInfoText__3M8UG"};